import { XInputValues } from './lib/gamepad';

export type * from './lib/api';
export type * from './lib/types';
export type * from './lib/gamepad';
export type * from './lib/hub';
export type * from './lib/keyboard';
export type * from './lib/mouse';
export type * from './lib/peer';
export type * from './lib/player';
export type * from './lib/stream';
export type * from './lib/system';
export type * from './lib/core';
export type * from './lib/user';
export type * from './lib/roster';
export type * from './lib/store';
export type * from './lib/electron';
export type * from './lib/logger';
export type * from './lib/remote';
export type * from './lib/process';
export type * from './lib/encoder';
export type * from './lib/input';
export type * from './lib/orchestrator';
export { XInputValues };

export enum IdentityPlatform {
  DISCORD = 'discord',
  TWITCH = 'twitch',
  CLERK = 'clerk',
}

export type Vector2 = {
  x: number;
  y: number;
};

export type PlaycastWindowState = 'minimized' | 'maximized' | 'closed' | 'normal';

export type PlaycastHostEdition = 'standard' | 'pavilion';

/**
 * Analytics segment for a host machine. Resolved server-side at WebSocket auth
 * and carried on host analytics events. `unknown` is returned when the server
 * checked but could not resolve a more specific classification (no fleet record,
 * or the lookup failed). The field is optional in the AUTH_SUCCESS payload, so a
 * server too old to send it omits the field entirely rather than sending
 * `unknown`. See docs/HOST_CLASSIFICATION.md.
 */
export type HostClassification = 'internal' | 'beta' | 'wild' | 'unknown';

export type Serializable = string | number | boolean | null | undefined | Serializable[] | { [key: string]: Serializable };

